<h1 mat-dialog-title>
  {{'alert.notification' | translate}}
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h1>
<div class="row">
  <div class="col-3 pr-0">
    <em class="material-icons confirm-ico">
      info
    </em>
  </div>
  <div class="col-9 pl-0" style="text-align: justify;">
    <div [innerHTML]="message | translate" style=" padding-top: 1px; padding-bottom: 20px;"></div>
  </div>
</div>
<div mat-dialog-actions class="justify-content-center mt-2">
  <button type="button" mat-raised-button color="primary" [mat-dialog-close]="true" (click)="onNoClick()"
    cdkFocusInitial>
    <mat-icon class="mr-0">done</mat-icon>{{'button.close' | translate}}
  </button>
</div>